export const actionTypes = {
    RESGISTER: 'RESGISTER',
    LOGIN: 'LOGIN',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    GET_PROFILE: 'GET_PROFILE',
    GET_PROFILE_SUCCESS: 'GET_PROFILE_SUCCESS',
    UPDATE_PROFILE: 'UPDATE_PROFILE',
    UPDATE_PROFILE_SUCCESS: 'UPDATE_PROFILE_SUCCESS',
    FOTGOT_PASSWORD: 'FOTGOT_PASSWORD',
    RESET_PASSWORD: 'RESET_PASSWORD',
    UPDATE_PASSWORD: 'UPDATE_PASSWORD',
    LOGOUT: 'LOGOUT',
    UPDATE_ADDRESS: 'UPDATE_ADDRESS',
    UPDATE_ADDRESS_SUCCESS: 'UPDATE_ADDRESS_SUCCESS',
}

export const registerAccount = payload => ({
    type: actionTypes.RESGISTER,
    payload,
})

export const login = payload => ({
    type: actionTypes.LOGIN,
    payload,
})

export const loginSuccess = payload => ({
    type: actionTypes.LOGIN_SUCCESS,
    payload,
})

export const getProfileSuccess = payload => ({
    type: actionTypes.GET_PROFILE_SUCCESS,
    payload,
})

export const getProfile = payload => ({
    type: actionTypes.GET_PROFILE,
    payload,
})

export const updateProfile = payload => ({
    type: actionTypes.UPDATE_PROFILE,
    payload,
})

export const updateProfileSuccess = payload => ({
    type: actionTypes.UPDATE_PROFILE_SUCCESS,
    payload,
})

export const forgotPassword = payload => ({
    type: actionTypes.FOTGOT_PASSWORD,
    payload,
})

export const resetPassword = payload => ({
    type: actionTypes.RESET_PASSWORD,
    payload,
})

export const updatePassword = payload => ({
    type: actionTypes.UPDATE_PASSWORD,
    payload,
})

export const logout = payload => ({
    type: actionTypes.LOGOUT,
    payload,
})

export const updateAddress = payload => ({
    type: actionTypes.UPDATE_ADDRESS,
    payload,
})
